import { supportedSubfolderLocaleCodes } from '@coursera-web/internationalization-lib';

const getXDPPageLink = ({
  subfolderLocaleCode,
  productPageUrlPath,
}: {
  subfolderLocaleCode?: string;
  productPageUrlPath: string;
}) => {
  if (subfolderLocaleCode && supportedSubfolderLocaleCodes.includes(subfolderLocaleCode)) {
    return `/${subfolderLocaleCode}${productPageUrlPath}`;
  }

  return productPageUrlPath;
};

export default getXDPPageLink;
